export const config = {
  unProtectedRoutes: [
    "/register",
    "/login/confirmation",
    "/register/email-verification-sent",
    "/login/email-verification-sent",
    "/register/personal",
    "/register/personal/profile",
    "/register/invite",
    "/businesses/new",
    "/login",
    "/_default",
    "/404",
    "/oauth/google-verify"
  ],
};
